import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import useRegistration from '../hooks/useRegistration';
import Button from '../components/common/Button';
import ConnectWallet from '../components/common/ConnectWallet';

export default function Home() {
  const { account } = useWallet();
  const { loading, registered } = useRegistration();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const refFromUrl = params.get('ref');

  useEffect(() => {
    if (refFromUrl) {
      navigate(`/register?ref=${refFromUrl}`, { replace: true });
    }
  }, [refFromUrl, navigate]);

  const primaryAction = () => {
    if (!account) return null;
    if (loading) return <Button variant="ghost" size="lg" loading>LOADING</Button>;
    if (registered) return (
      <Button variant="primary" size="lg" onClick={() => navigate('/dashboard')}>
        LAUNCH DASHBOARD
      </Button>
    );
    return (
      <Button variant="primary" size="lg" onClick={() => navigate('/register')}>
        REGISTER &amp; INVEST
      </Button>
    );
  };

  return (
    <div className="main-content">
      <section className="hero fade-in">
        <div className="tagline">Next-Gen DeFi Trading Platform</div>
        <h1>CRYPTO<br />PAY</h1>
        <p className="text-dim" style={{ maxWidth: 620, margin: '0 auto 30px' }}>
          Enter the market. Stake. Earn ROI daily. Build your team. Withdraw on your terms.
        </p>
        <div className="hero-actions">
          {account ? (
            <>
              {primaryAction()}
              {registered && (
                <Button variant="ghost" size="lg" onClick={() => navigate('/invest')}>
                  ADD INVESTMENT
                </Button>
              )}
            </>
          ) : (
            <ConnectWallet />
          )}
        </div>
      </section>

      <section className="hero-features">
        <div className="hero-feature">
          <div className="feat-icon">◈</div>
          <h4 className="text-primary">Daily ROI</h4>
          <p>0.5% payouts every weekday for 400 trading days. Non-stop yield.</p>
        </div>
        <div className="hero-feature">
          <div className="feat-icon">◆</div>
          <h4 className="text-success">20-Level Team</h4>
          <p>Earn commissions up to 20 levels deep from your referral tree.</p>
        </div>
        <div className="hero-feature">
          <div className="feat-icon">★</div>
          <h4 className="text-warning">11 Reward Tiers</h4>
          <p>Bronze to Legend — climb the ranks for bonus rewards.</p>
        </div>
      </section>
    </div>
  );
}
